import { makeVar, useReactiveVar } from '@apollo/client';

// oxlint-disable-next-line typescript/explicit-function-return-type
export const createReactiveVar = <T>(initialValue: T) => {
  const reactiveVar = makeVar<T>(initialValue);

  const setter = (value: T): void => {
    reactiveVar(value);
  };

  const useHook = () => [useReactiveVar(reactiveVar), setter] as const;

  return { setter, useHook };
};
